module.exports = __webpack_public_path__ + "img/family_travel_insurance.dcc1ce6d.jpg";